import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Form, Modal, Spin } from "antd";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { WholeNumberFormat } from "../../../components/FormattersTS";
import { DateTimeFormat } from "../../../components/FormattersTS";
import CustomerVehicleTareFormItems from "./CustomerVehicleTareFormItems";
import CustomerVehicleResource from "../api/CustomerVehicleResource";
import { axiosErrorHandler } from "../../../../../swzutils";
const columns = [{
        key: "effectiveFrom",
        title: 'Effective',
        dataIndex: 'effectiveFrom',
        width: '25%',
        render: (text /*, record*/) => {
            return _jsx(DateTimeFormat, { value: text });
        }
    }, {
        key: "atSenderReceiver",
        title: 'Tare At',
        dataIndex: ['atSenderReceiver', 'companyName'],
        width: '60%'
    }, {
        key: 'tare',
        title: 'Tare (tn)',
        dataIndex: 'tareTonnes',
        width: '15%',
        render: (text /*, record*/) => {
            return _jsx(WholeNumberFormat, { value: text });
        }
    }];
const CustomerVehicleTareModal = ({ open, customer, customerVehicle, onClose }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const tableRef = useRef(null);
    const [form] = Form.useForm();
    const onOkClicked = (formValues) => {
        setNetworkRequestInProgress(true);
        const request = {
            atSenderReceiverId: formValues.tareAtSenderReceiverId,
            tareTonnes: formValues.tareTonnes,
            effectiveAt: formValues.tareEffectiveAt
        };
        CustomerVehicleResource.createTare(customer.id, customerVehicle.id, request, tare => {
            tableRef.current?.prependRecord(tare);
            form.resetFields();
        }, axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    return (_jsx(Modal, { title: "Customer Vehicle Tares", open: open, onCancel: onClose, destroyOnHidden: true, footer: [
            _jsx(Button, { onClick: onClose, children: "Close" }, "close"),
        ], children: _jsxs(Spin, { spinning: networkRequestInProgress, children: [_jsxs("h2", { children: [customerVehicle?.registration, " - ", customerVehicle?.description] }), _jsx(Form, { layout: "vertical", form: form, onFinish: onOkClicked, children: _jsx(CustomerVehicleTareFormItems, { tenantId: customer.tenant.id, onAddClicked: form.submit }) }), _jsx(PaginatedFilterableTable, { ref: tableRef, tableKey: 'customerVehicleTareTable', dataUri: `/admin/v1/customers/${customer.id}/vehicles/${customerVehicle?.id}/tares`, columns: columns, refreshOnSelectedTenantChanged: false, minWidthBeforeScrolling: 200, initialFilters: {
                        active: [true]
                    } })] }) }));
};
export default CustomerVehicleTareModal;
